<template>
  <div class="yxtbiz-rank-setter_rule">
    <yxt-form
      ref="rankForm"
      :model="rankForm"
      :rules="rules"
      :enableDetectFieldsChange="isInitialFinished"
      label-position="top"
    >
      <yxt-form-item
        :label="$t('pc_biz_rank_dimension').d('排行维度')"
        prop="dimensionCode"
        class="yxtbiz-rank-setter_rule_select_item"
      >
        <yxt-select
          v-model="rankForm.dimensionCode"
          class="mt8 yxtbiz-rank-setter_rule_select"
          size="small"
          :placeholder="$t('pc_biz_rank_dimension_tip').d('请选择排行维度')"
          @change="onConfigChange"
        >
          <yxt-option
            v-for="item in dimensionList"
            :label="$t(item.label).d(item.text)"
            :value="item.key"
            :key="item.key"
          ></yxt-option>
        </yxt-select>
      </yxt-form-item>
      <yxt-form-item
        prop="dateType"
        :label="$t('pc_biz_rank_cycle').d('排行周期')"
        class="mb15"
      >
        <yxt-checkbox-group
          v-model="rankForm.dateType"
          class="yxtbiz-rank-setter_rule_cycle"
        >
          <yxt-checkbox
            v-for="item in dateList"
            :key="item.type"
            :label="item.type"
          >
            {{ $t(item.label).d(item.text) }}
          </yxt-checkbox>
        </yxt-checkbox-group>
      </yxt-form-item>
      <yxt-form-item
        prop="objectCode"
        class="yxtbiz-rank-setter_rule_select_item"
      >
        <div slot="label">
          {{ $t('pc_biz_rank_participate_object').d('参与对象') }}
          <span class="yxt-form-item__required mr2"
            ><i class="required-dot"></i
          ></span>
          <yxt-tooltip
            placement="right"
            :content="
              $t('pc_biz_rank_participate_object_prompt').d(
                '员工榜单实时更新，部门人均榜单和部门总计榜单隔天更新'
              )
            "
          >
            <yxt-svg
              class="color-gray-6 hover-primary-6"
              width="16px"
              height="16px"
              icon-class="icons/question-cirlce-o"
            />
          </yxt-tooltip>
        </div>
        <yxt-select
          class="mt8 yxtbiz-rank-setter_rule_select"
          size="small"
          v-model="rankForm.objectCode"
          @change="onConfigChange"
          :placeholder="
            $t('pc_biz_rank_participate_object_tip').d('请选择参与对象')
          "
        >
          <yxt-option
            v-for="item in objectList"
            :label="$t(item.label).d(item.text)"
            :value="item.key"
            :key="item.key"
          ></yxt-option>
        </yxt-select>
      </yxt-form-item>
      <div
        v-if="rankForm.objectCode === 'user'"
        class="yxtbiz-rank-setter_rule_user_scope_box mb24"
      >
        <yxt-form-item
          prop="userScope"
          class="yxtbiz-rank-setter_rule_select_item"
        >
          <div slot="label" class="flex yxtbiz-rank-setter_rule_user_scope">
            <span>{{ $t('pc_biz_rank_object_scope').d('对象范围') }}</span>
            <span class="yxt-form-item__required"
              ><i class="required-dot"></i
            ></span>
            <yxt-popover placement="top-start" @after-leave="onUserScopeChange">
              <div class="yxtbiz-rank-setter_rule_user_scope_tip">
                <div class="standard-size-16 yxtf-weight-6 mb8">
                  {{ $t(rangeList[tipIndex].label) }}
                </div>
                <div class="standard-size-12 text-8c">
                  {{ $t('pc_biz_rank_sketch_map').d('示意图') }}（{{
                    tipIndex + 1
                  }}/{{ rangeList.length }}）
                </div>
                <div class="yxtbiz-rank-setter_rule_user_scope_tip_img">
                  <span
                    class="yxtbiz-rank-setter_rule_arrow"
                    @click="switchTip('prev')"
                  >
                    <i class="yxt-icon-arrow-left"></i
                  ></span>
                  <div>
                    <yxt-image
                      width="208px"
                      height="152px"
                      :src="
                        `${$staticBaseUrl}ufd/55a3e0/ssp/pc/img/user_scope` +
                          rangeList[tipIndex].type +
                          '.png'
                      "
                    />
                  </div>
                  <span
                    class="yxtbiz-rank-setter_rule_arrow"
                    @click="switchTip('next')"
                  >
                    <i class="yxt-icon-arrow-right"></i
                  ></span>
                </div>
                <div
                  class="
                    yxtbiz-rank-setter_rule_icon_area
                    standard-size-12
                    text-8c
                  "
                >
                  <yxt-image
                    width="12px"
                    height="12px"
                    class="mr4"
                    :src="`${$staticBaseUrl}ufd/55a3e0/ssp/pc/img/scope_position.png`"
                  />

                  {{ $t('pc_biz_rank_belong_dept').d('所属部门') }}

                  <yxt-image
                    width="12px"
                    height="12px"
                    class="mr4 ml24"
                    :src="`${$staticBaseUrl}ufd/55a3e0/ssp/pc/img/scope_check.png`"
                  />

                  {{ $t('pc_biz_rank_statistical_range').d('统计范围') }}
                </div>
              </div>
              <yxt-button
                slot="reference"
                type="text"
                class="font-size-12 ml8"
                >{{ $t('pc_biz_rank_view_example').d('查看示例') }}</yxt-button
              >
            </yxt-popover>
          </div>
          <yxt-select
            v-model="rankForm.userScope"
            class="mt8 yxtbiz-rank-setter_rule_select"
            size="small"
            :placeholder="
              $t('pc_biz_rank_object_scope_tip').d('请选择对象范围')
            "
            @change="onUserScopeChange"
          >
            <yxt-option
              v-for="item in rangeList"
              :label="$t(item.label).d(item.text)"
              :value="item.type"
              :key="item.type"
            ></yxt-option>
          </yxt-select>
        </yxt-form-item>
        <yxt-form-item
          v-if="module === 'xuanxing'"
          prop="excludeUser"
          class="
            yxtbiz-rank-setter_rule_select_item
            yxtbiz-rank-setter_rule_excludeUser
          "
        >
          <div slot="label">
            <yxt-checkbox
              style="align-items: normal;"
              v-model="addExcludeUser"
              @change="addExcludeUserChange"
            >
              {{ $t('pc_biz_rank_add_exclude_person').d('添加排除人员') }}
            </yxt-checkbox>
          </div>
          <yxt-select
            v-show="addExcludeUser"
            class="mt8 ml24 yxtbiz-rank-setter_rule_select_user"
            size="small"
            v-model="rankForm.excludeUser"
            multiple
            :placeholder="$t('pc_biz_lbl_selecttip').d('请选择')"
            icon-name="more"
            hidden-option
            collapse-tags
            value-key="id"
            prop-label="fullname"
            @visible-change="showSelecter('persons')"
          >
            <template slot="tag" slot-scope="{ data }">
              <span>{{ data.currentLabel }}</span>
            </template>
          </yxt-select>
        </yxt-form-item>
      </div>
      <yxt-form-item
        v-else
        prop="deptScope"
        class="
          yxtbiz-rank-setter_rule_dept_scope_box
          yxtbiz-rank-setter_rule_select_item
        "
      >
        <div slot="label" class="flex yxtbiz-rank-setter_rule_user_scope">
          <span>{{ $t('pc_biz_rank_object_scope').d('对象范围') }}</span>
          <span class="yxt-form-item__required"
            ><i class="required-dot"></i
          ></span>
          <span class="text-8c standard-size-12 ml8">{{
            $t('pc_biz_rank_dept_limit').d('可选3-50个')
          }}</span>
        </div>
        <yxt-select
          class="mt8 yxtbiz-rank-setter_rule_select_user"
          size="small"
          v-model="rankForm.deptScope"
          multiple
          :placeholder="$t('pc_biz_lbl_selecttip').d('请选择')"
          icon-name="more"
          hidden-option
          collapse-tags
          value-key="id"
          prop-label="name"
          @visible-change="showSelecter('department')"
        >
          <template slot="tag" slot-scope="{ data }">
            <span>{{ data.currentLabel }}</span>
          </template>
        </yxt-select>
      </yxt-form-item>
      <yxt-form-item
        :label="$t('pc_biz_rank_more_config').d('更多配置')"
        prop="minScopeOpen"
      >
        <yxt-checkbox
          v-model="rankForm.minScopeOpen"
          :true-label="1"
          :false-label="0"
        >
          {{ $t(configName.label).d(configName.text) }}
          <yxt-input-number
            class="mh8 yxtbiz-rank-setter_rule_input_number"
            size="small"
            v-model="rankForm.minScopeValue"
            :precision="0"
            :min="0"
            :max="9999"
            @blur="onScopeValueBlur"
          ></yxt-input-number>
          {{ $t('pc_biz_rank_no_rank').d('不参与排名') }}
        </yxt-checkbox>
      </yxt-form-item>
    </yxt-form>
    <!-- 选择人员 -->
    <yxt-drawer destroy-on-close size="960px" :visible.sync="dialogVisible">
      <div slot="title">
        <span v-if="selectorTitle.length > 1" class="standard-size-12 text-59">
          <span
            v-for="(item, index) of selectorTitle"
            :key="index"
            :class="{
              'text-8c hand': index !== selectorTitle.length - 1,
              'yxtf-weight-6': index === selectorTitle.length - 1
            }"
            @click="onClickTitle(index)"
          >
            <span
              :class="{ 'hover-primary-6': index !== selectorTitle.length - 1 }"
            >
              {{ item }}</span
            >
            <span v-if="index !== selectorTitle.length - 1" class="ml4 mr4"
              ><i class="yxt-icon-arrow-right"></i
            ></span>
          </span>
        </span>
        <span v-else>{{ selectorTitle[0] }}</span>
      </div>
      <YxtbizRangeSelector
        :selected="selectData"
        :tabs="tabs"
        :limit="limit"
        :dataPermissionCode="dataPermissionCode"
        :functionCode="functionCode"
        ref="rangeSelector"
      >
      </YxtbizRangeSelector>
      <div slot="footer">
        <yxt-button @click="dialogVisible = false" plain>
          {{ $t('pc_biz_common_cancel_mini') }}</yxt-button
        >
        <yxt-button type="primary" @click="getRangeSelector">{{
          $t('pc_biz_common_btn_sure')
        }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>
<script>
import {
  dimensionList,
  dateList,
  objectList,
  rangeList,
  configList,
  userContentList,
  deptContentList,
  dimensionContentList
} from './config';

export default {
  props: {
    // 导航的功能权限
    functionCode: {
      type: String,
      default: ''
    },
    // 数据权限code
    dataPermissionCode: {
      type: String,
      default: ''
    },
    // 是否是集团版
    enableGroupCorp: {
      type: Boolean,
      default: false
    },
    // 抽屉的标题
    title: {
      type: Array,
      default: () => []
    },
    // 使用平台标识 -- op: 运营平台， xuanxing: 主站
    module: {
      type: String,
      default: 'xuanxing'
    }
  },
  data() {
    var checkDeptScope = (rule, value, callback) => {
      if (!value || value.length < 3) {
        callback(
          new Error(
            this.$t('pc_biz_rank_dept_scope_min_tip').d('至少选择3个部门')
          )
        );
      } else {
        callback();
      }
    };
    return {
      dimensionList, // 排行维度可选项
      dateList, //  排行周期可选项
      addExcludeUser: false, // 添加排除人员
      dialogVisible: false, // 显示选人、选部门组件
      originObjectCode: '',
      originRankContent: [],
      originDimensionCode: '',
      rankForm: {
        dimensionCode: 'integral', // 排行维度
        dateType: [1, 2, 3, 4, 5], // 排行周期
        objectCode: 'user', // 参与对象
        rankContent: [], // 展示内容
        userScope: 1, //  对象范围
        excludeUser: [], // 排除人员
        deptScope: [], // 部门对象范围
        minScopeOpen: 1, // 排行维度过滤开关
        minScopeValue: 0 // 排行维度过滤阈值
      },
      rules: {
        dimensionCode: [
          {
            required: true,
            message: this.$t('pc_biz_rank_dimension_tip').d('请选择排行维度')
          }
        ],
        dateType: [
          {
            required: true,
            message: this.$t('pc_biz_rank_cycle_tip').d('至少选择1个排行周期')
          }
        ],
        deptScope: [
          {
            validator: checkDeptScope
          }
        ],
        excludeUser: [
          {
            validator: this.checkExcludeUser,
            trigger: 'blur'
          }
        ]
      },
      isInitialFinished: false,
      configName: {
        label: 'pc_biz_rank_employee_integral_less',
        text: '员工积分小于等于'
      }, // 更多配置的文案
      selectData: {
        persons: [],
        department: []
      }, // 选择的人员/部门数据
      tabs: [{ type: 'persons' }], // 选择人员/部门组件的tab配置
      limit: 200, // 选择人员上限 200，选择部门上限 50
      tipIndex: 1 // 对象范围示意图当前显示的下标
    };
  },
  computed: {
    // 对象范围可选项
    rangeList() {
      const list = JSON.parse(JSON.stringify(rangeList));
      this.tipIndex = 0;
      return list;
    },
    // 参与对象可选项
    objectList() {
      const list = JSON.parse(JSON.stringify(objectList));
      this.module !== 'xuanxing' && list.splice(1, 2);
      return list;
    },
    // 选择人员/部门组件的标题
    selectorTitle() {
      const title = this.title.length
        ? JSON.parse(JSON.stringify(this.title))
        : [this.$t('pc_biz_rank_setter_title').d('添加榜单')];
      if (this.rankForm.objectCode === 'user') {
        title.push(this.$t('pc_biz_rank_add_exclude_person').d('添加排除人员'));
      } else {
        title.push(this.$t('pc_biz_rank_select_dept').d('选择部门'));
      }
      return title;
    }
  },
  methods: {
    // 初始化数据
    init(data) {
      Object.keys(this.rankForm).forEach(k => {
        if (k === 'excludeUser') {
          this.rankForm[k] = data[k]
            ? data[k].map(d => ({
              id: d.userId,
              fullname: d.fullName,
              orgId: d.orgId,
              orgName: d.orgName
            }))
            : [];
          this.addExcludeUser = !!(data[k] && data[k].length);
          this.selectData.persons = JSON.parse(
            JSON.stringify(this.rankForm[k])
          );
        } else {
          this.rankForm[k] = data[k];
          k === 'deptScope' &&
            (this.selectData.department = JSON.parse(
              JSON.stringify(this.rankForm[k])
            ));
        }
      });
      // 保存原始对象,展示内容
      this.originObjectCode = this.rankForm.objectCode;
      this.originRankContent = this.rankForm.rankContent;
      this.originDimensionCode = this.rankForm.dimensionCode;
      this.$nextTick(() => {
        this.isInitialFinished = true;
      });
      // 更多设置、榜单名称初始化
      this.onConfigChange();
    },
    // 点击选择人员/部门组件抽屉标题
    onClickTitle(index) {
      if (this.selectorTitle.length > 2 && !index) {
        this.$emit('handleClose');
      }

      if (index === this.selectorTitle.length - 2) {
        this.dialogVisible = false;
      }
    },
    // 校验排除人员
    checkExcludeUser(rule, value, callback) {
      if (
        this.rankForm.objectCode === 'user' &&
        this.addExcludeUser &&
        (!value || !value.length)
      ) {
        callback(
          new Error(
            this.$t('pc_biz_rank_exclude_person_tip').d('请选择排除人员')
          )
        );
      } else {
        callback();
      }
    },
    // 添加排除人员 更改时
    addExcludeUserChange() {
      this.$refs.rankForm.validateField('excludeUser');
    },
    // 添加部门 更改时
    addDeptscopeChange() {
      this.$refs.rankForm.validateField('deptScope');
    },
    // 显示 选择人员/部门组件
    showSelecter(type) {
      this.tabs =
        type === 'persons'
          ? [{ type: 'persons' }]
          : [
            {
              type: 'department',
              checkStrictly: true,
              childrenIncluded: 4,
              functions: false
            }
          ];
      type === 'persons'
        ? (this.selectData[type] = this.rankForm.excludeUser)
        : (this.selectData[type] = this.rankForm.deptScope);
      this.limit = type === 'persons' ? 200 : 50;
      this.dialogVisible = true;
    },
    // 排行维度 与 参与对象 改变时，更多设置、榜单名称随之更改
    onConfigChange() {
      const index = this.getIndex();
      this.configName = configList[index[0]][index[1]];
    },
    // 选择人员/部门
    async getRangeSelector() {
      const isValid = await this.$refs.rangeSelector.validate();
      if (isValid) {
        const data = await this.$refs.rangeSelector.getSelectData();
        const type = this.tabs[0].type;
        this.selectData[type] = data[type];
        if (type === 'persons') {
          this.rankForm.excludeUser = this.selectData[type];
          this.addExcludeUserChange();
        } else {
          this.rankForm.deptScope = this.selectData[type];
          this.addDeptscopeChange();
        }
        this.dialogVisible = false;
      }
    },
    // 对象范围 更改时，计算当前应显示的示意图下标
    onUserScopeChange() {
      this.tipIndex = this.rangeList.findIndex(
        r => r.type === this.rankForm.userScope
      );
    },
    // 切换示意图
    switchTip(type) {
      if (type === 'prev' && this.tipIndex !== 0) {
        this.tipIndex--;
      }
      if (type === 'next' && this.tipIndex !== this.rangeList.length - 1) {
        this.tipIndex++;
      }
    },
    getIndex() {
      const one =
        this.dimensionList.find(d => d.key === this.rankForm.dimensionCode)
          .type - 1;
      const two =
        this.objectList.find(d => d.key === this.rankForm.objectCode).type - 1;
      return [one, two];
    },
    // 排行维度过滤阈值 删除后恢复成默认0
    onScopeValueBlur() {
      !this.rankForm.minScopeValue &&
        this.rankForm.minScopeValue !== 0 &&
        (this.rankForm.minScopeValue = 0);
    },
    getStyleConfig() {
      const list = [];
      let contentList = [];
      let date = { order: 0, type: 0 };
      // 获取选中的排行周期
      this.dateList.forEach(d => {
        if (this.rankForm.dateType.includes(d.type)) {
          list.push(d);
          if (d.order > date.order) {
            date = d;
          }
        }
      });

      // 计算展示内容的可选项
      // 参与对象 选择了 员工
      if (this.rankForm.objectCode === 'user') {
        const list = JSON.parse(JSON.stringify(userContentList));
        // 对象范围 选择了 集团全体员工
        if (this.rankForm.userScope === 2) {
          list.splice(2, 1);
        } else {
          list.splice(3, 1);
        }
        contentList = list;
      } else {
        // 参与对象 选择了 部门
        contentList = JSON.parse(JSON.stringify(deptContentList));
      }
      // 排行维度
      const index = this.getIndex();
      contentList.push(dimensionContentList[index[0]][index[1]]);
      const content =
        this.originObjectCode !== this.rankForm.objectCode ||
        this.originDimensionCode !== this.rankForm.dimensionCode
          ? contentList
          // 默认选中部门名称
          // .filter(c => !c.select)
            .map(c => c.type)
            .join(',')
          : this.originRankContent.join(',');
      return { dateList: list, date: date.type, contentList, content };
    }
  }
};
</script>
